export default "__VITE_ASSET__CvZ$wouW__"